import { IconProps } from "../../utils/global-types/global-types";

const ChevronDownIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 8 8"
      className={className ? className : "w-6 h-6"}
      {...rest}
    >
      <g clipPath="url(#clip0_1106_204020)">
        <path
          fill="currentColor"
          d="m4.471 5.804 2.667-2.666a.667.667 0 0 0-.943-.943L4 4.39 1.805 2.195a.667.667 0 0 0-.943.943L3.53 5.804a.667.667 0 0 0 .942 0"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_1106_204020">
          <path fill="#fff" d="M8 0v8H0V0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};

export default ChevronDownIcon;
